import React from 'react'
import { Col } from 'react-bootstrap'

import DatePicker from '../../../../../../DatePicker'
import Field from '../../../../../../Field'
import { IFilterType } from '../../../../../types'

const DaterangeType = (props: IFilterType): React.ReactElement => {
  const { filter = {}, index } = props

  return (
    <Col md={filter.colWidth ? filter.colWidth : 6} key={index}>
      <Field name={filter.name as string} label={filter.label}>
        <DatePicker
          isRange
          block
          timePicker={!filter.hideTimePicker}
          enforceFullDay={filter.enforceFullDay}
        />
      </Field>
    </Col>
  )
}

export default DaterangeType
